/**
 * Utility: auditLogger.js
 * Frontend activity trail for tracking Super Admin actions (deletions, tax edits, user bans, balance adjustments).
 */

const AUDIT_LOG_KEY = 'QV_ADMIN_AUDIT_LOGS';

export const auditLogger = {
  logAction(actionType, details = {}) {
    try {
      const logs = this.getLogs();
      const newEntry = {
        id: `log_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
        actionType,
        details,
        timestamp: new Date().toISOString(),
        adminEmail: localStorage.getItem('adminEmail') || sessionStorage.getItem('adminEmail') || 'superadmin@quvikme.com',
      };

      logs.unshift(newEntry);
      // Keep last 100 entries locally
      const trimmed = logs.slice(0, 100);
      localStorage.setItem(AUDIT_LOG_KEY, JSON.stringify(trimmed));
      console.log(`📋 [AUDIT LOG] ${actionType}:`, newEntry);
    } catch (e) {
      console.warn('Failed to record audit log:', e);
    }
  },

  getLogs() {
    try {
      const raw = localStorage.getItem(AUDIT_LOG_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  },

  clearLogs() {
    localStorage.removeItem(AUDIT_LOG_KEY);
  }
};

export default auditLogger;
